module.exports = __webpack_public_path__ + "static/media/logo.5f55abf0.png";